/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosPromise } from 'axios';

import {
  IProfessionalsData,
  IStudentsData,
  IFinancesData,
  IVindiFinancesData,
  IVindiPaymentStatusData,
  IVindiReportsFinancesData,
  IVindiPaymentMethodsData,
  IVindiPaymentByMonthAndYearData,
} from '~/models/Boss';

import api from './api';

const IBossService = {
  getReportsStudents(query?: string): AxiosPromise<IStudentsData> {
    return api.get(`/admin-reports/iboss-student?${query}`);
  },

  getReportsProfessionals(query?: string): AxiosPromise<IProfessionalsData> {
    return api.get(`/admin-reports/iboss-professional?${query}`);
  },

  getReportsFinances(query: string): AxiosPromise<IFinancesData> {
    return api.get(`/admin-reports/iboss-payment?${query}`);
  },

  newGetReportsFinances(
    query: string,
  ): AxiosPromise<IVindiPaymentStatusData[]> {
    return api.get(`/admin-reports/vindi-payment-status?${query}`);
  },

  //! New
  getVindiPaymentStatus(
    query: string,
  ): AxiosPromise<IVindiPaymentStatusData[]> {
    return api.get(`/admin-reports/vindi-payment-status?${query}`);
  },

  getVindiReportsFinances(
    query: string,
  ): AxiosPromise<IVindiReportsFinancesData[]> {
    return api.get(`/admin-reports/vindi-plan?${query}`);
  },

  getVindiPaymentMethods(
    query: string,
  ): AxiosPromise<IVindiPaymentMethodsData[]> {
    return api.get(`/admin-reports/vindi-payment-method?${query}`);
  },

  getVindiPaymentByMonthAndYear(
    query: string,
  ): AxiosPromise<IVindiPaymentByMonthAndYearData[]> {
    return api.get(`/admin-reports/vindi-historic?${query}`);
  },
};

export default IBossService;
